import React from 'react';
import { Callout } from '@lithos';
import { css } from '@emotion/css';

const FormErrorFeedback = ({
  title,
  errors,
}: {
  title?: string;
  errors: {
    title?: string;
    message: string;
  }[];
}) => {
  const errorListCss = css``;

  return (
    <Callout
      title={title}
      variant="danger"
      content={
        <ul className={errorListCss}>
          {errors.map((entry) => {
            return (
              <li key={entry.title}>
                {entry?.title && <h4>{entry.title}</h4>}
                <p>{entry.message}</p>
              </li>
            );
          })}
        </ul>
      }
    />
  );
};

export default FormErrorFeedback;
